import { PageContentWrapperDesktop, MenuContainerDesktop } from '../styled';
import { SideBarType } from '../hooks';
import ContentMenu from './menu/ContentMenu';
import CorporatePagesSwitch from './corporate/CorporatePagesSwitch';
import SeturPagesSwitch from './setur/SeturPagesSwitch';

const StaticPageDesktop = ({ type }: { type: SideBarType }) => {
  return (
    <PageContentWrapperDesktop>
      <ContentMenu type={type} />
      <MenuContainerDesktop>
        {type === 'corporate' ? <CorporatePagesSwitch /> : null}
        {type === 'setur' ? <SeturPagesSwitch /> : null}
      </MenuContainerDesktop>
    </PageContentWrapperDesktop>
  );
};

export default StaticPageDesktop;
